import React from 'react';

import { Component as LineItemCell } from '../common/LineItemCell.jsx';
import * as ListContainer from '../common/ListContainer.jsx';
import Name from '../utility/Name.jsx';
import Token from '../utility/Token.jsx';
import Utilities from '../utility/Utilities.jsx';

function LineItems(props) { return <ListContainer.Component cellComponent={LineItemCell} records={Utilities.Inventory.getRecords(props)} {...props} /> }

const TypeConfig = {
    panel: {
        block: () => ListContainer.TypeConfig.panel.block(Name.Content.PurchaseOrderLineItem),
        style: ListContainer.TypeConfig.panel.style,
        visibility: () => {
            return {
                expanded: false,
                label: 'Visibility',
                options: [
                    { display: 'Created Date', name: Token.Date, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Date, config, Name.Block.Inventory.Meta) },
                    { display: 'Dimensions', name: Token.Inventory.Dimensions, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Dimensions, config, Name.Block.Inventory.Meta) },
                    { display: 'Alternate Dimensions', name: Token.Inventory.AlternateDimensions, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.AlternateDimensions, config, Name.Block.Inventory.Meta) },
                    { display: 'Inventory Number', name: Token.Inventory.Number, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Number, config, Name.Block.Inventory.Meta) },
                    { display: 'SKU', name: Token.Inventory.SKU, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.SKU, config, Name.Block.Inventory.Meta) }
                ],
                visible: () => false
            };
        }
    }
}

export {
    LineItems as Component,
    TypeConfig
}